import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrentUser, login, updatePassword, forgotPassword, verifyOtp, resetPassword } from "../services/authService";
import { saveAuth } from "../utils/authStorage";


// Async thunk for user login
export const loginUser = createAsyncThunk(
  "auth/loginUser",
    async ({ email, password }, thunkAPI) => {
      try {
        const res = await login(email, password);
        saveAuth(res);
        return res;
      } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
      }
    }
);

//Get user from local storage on app load
export const fetchUser = createAsyncThunk("auth/fetchUser", async (_, thunkAPI) => {
  try {
    const user = await getCurrentUser();
    const token = localStorage.getItem("token");
    return { user, token };
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

//update user password
export const updateUserPassword = createAsyncThunk(
  "auth/updateUserPassword",
  async ({ currentPassword, newPassword }, thunkAPI) => {
    try {
      const res = await updatePassword(currentPassword, newPassword);
      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

//forgotpassword send otp to email
export const sendOtp = createAsyncThunk(
  "auth/sendOtp",
  async ({ email }, thunkAPI) => {
    try {
      const res = await forgotPassword(email);
      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

//verify otp
export const userVerifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async ({ email, otp }, thunkAPI) => {
    try {
      const res = await verifyOtp(email, otp);
      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

//reset password
export const userResetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ newPassword, resetToken }, thunkAPI) => {
    try {
      const res = await resetPassword(newPassword, resetToken);
      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: localStorage.getItem("token") || null,
    isLoading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.clear();
    },
  },
    extraReducers: (builder) => {
      builder
        .addCase(loginUser.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(loginUser.fulfilled, (state, action) => {
          state.isLoading = false;
          state.loginResponse = action.payload.user;
          state.token = action.payload.token;
        })
        .addCase(loginUser.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(fetchUser.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(fetchUser.fulfilled, (state, action) => {
            console.log('reduxdata:',action.payload);
            
          state.isLoading = false;
          state.user = action.payload.user;
          state.token = action.payload.token;
        })
        .addCase(fetchUser.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(updateUserPassword.fulfilled, (state, action) => {
          state.isLoading = false;
          state.user = { ...state.user, ...action.payload };
        })
        .addCase(updateUserPassword.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(sendOtp.fulfilled, (state, action) => {
          state.isLoading = false;
        })
        .addCase(sendOtp.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }).addCase(userVerifyOtp.fulfilled, (state, action) => {
          state.isLoading = false;
        })
        .addCase(userVerifyOtp.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(userResetPassword.fulfilled, (state, action) => {
          state.isLoading = false;
        })
        .addCase(userResetPassword.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        });
    }

});

export const { logout } = authSlice.actions;
export default authSlice.reducer;